import React, { useState } from 'react';
import { useAppContext } from 'Context/ReactAppContext';
import { formatAmountForLocale } from 'Utils/currency-config-for-locale/currencyConfigForLocale';
import { Spinner } from 'Components/frameworks/spinner/Spinner';
type Props = {
  currency: string;
  label: string;
  noEditMode: boolean;
  onDelete: (arg0: ReadonlyArray<AdditionalServiceWithScheduleType>) => Promise<any>;
  price: number;
  services: ReadonlyArray<AdditionalServiceWithScheduleType>;
};
export const ServiceLine = ({ currency, label, noEditMode, onDelete, price, services }: Props) => {
  const { locale } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  return (
    <li className="flex items-baseline gap-5 leading-1">
      <span className="flex-1">{label}</span>
      <span className="whitespace-nowrap text-16 font-bold text-sienna">
        {formatAmountForLocale(price, locale, currency)}
      </span>
      {!isLoading && !noEditMode ? (
        <button
          className="h-12 shrink-0 text-20"
          data-testid="DeleteReservedServiceButton"
          onClick={() => {
            setIsLoading(true);
            onDelete(services).catch((e) => {
              setIsLoading(false);
              throw e;
            });
          }}
          type="button"
        >
          &times;
        </button>
      ) : (
        !noEditMode && <Spinner className="ms-10 self-center text-current" size="small" />
      )}
    </li>
  );
};
